import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "base-modal__bar-title" }
const _hoisted_2 = {
  key: 0,
  class: "base-modal__bar-right"
}
const _hoisted_3 = { class: "base-modal__close-btn" }
const _hoisted_4 = { class: "base-modal__body" }

import { i18n } from "@/i18n";
import {
	computed,
	ref
} from "vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import { useBreakpoints } from "@/composables/useBreakpoints";

export type QuasarTransitions =
	"slide-right"
	| "slide-left"
	| "slide-up"
	| "slide-down"
	| "fade"
	| "scale"
	| "rotate"
	| "flip-right"
	| "flip-left"
	| "flip-up"
	| "flip-down"
	| "jump-right"
	| "jump-left"
	| "jump-up"
	| "jump-down"

type ModalProps = {
	loading?: boolean,
	persistent?: boolean,
	closeByClickOutside?: boolean,
	transitionShow?: QuasarTransitions,
	transitionHide?: QuasarTransitions,
	transitionDuration?: number,
	width?: number | string,
	maxWidth?: number | string,
	minWidth?: number | string,
	height?: number | string,
	maxHeight?: number | string,
	minHeight?: number | string,
	title?: string,
	fullscreenOnMobile?: boolean,
	stackHeaderRightOnMobile?: boolean,
	hideHeader?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    loading: { type: Boolean, default: false },
    persistent: { type: Boolean, default: true },
    closeByClickOutside: { type: Boolean, default: false },
    transitionShow: { default: "scale" },
    transitionHide: { default: "scale" },
    transitionDuration: { default: 300 },
    width: { default: "55vw" },
    maxWidth: { default: "55vw" },
    minWidth: {},
    height: { default: "95vh" },
    maxHeight: { default: "95vh" },
    minHeight: {},
    title: {},
    fullscreenOnMobile: { type: Boolean, default: false },
    stackHeaderRightOnMobile: { type: Boolean, default: false },
    hideHeader: { type: Boolean, default: false }
  },
  emits: ["on-decline", "on-accept", "on-close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const resolvedTitle = computed(() => props.title ?? String(i18n.global.t('information')))

const emit = __emit

const dialog = ref(false)
const { isMobile } = useBreakpoints()
const isMobileFullscreen = computed(() => props.fullscreenOnMobile && isMobile.value)

const computedStyles = computed(() => {
	if (isMobileFullscreen.value) {
		return {
			width: '100vw',
			height: '100dvh',
			maxWidth: '100vw',
			maxHeight: '100dvh'
		}
	}

	// Предел ширины проставляется инлайном намеренно: у Quasar на внутреннем контейнере
	// диалога свой max-width, и перебить его из таблицы стилей нельзя.
	return {
		maxHeight: typeof props.maxHeight === 'number'
			? `${props.maxHeight}px`
			: props.maxHeight,
		maxWidth: typeof props.maxWidth === 'number'
			? `${props.maxWidth}px`
			: props.maxWidth,
		minWidth: typeof props.minWidth === 'number'
			? `${props.minWidth}px`
			: props.minWidth,
		width: typeof props.width === 'number'
			? `${props.width}px`
			: props.width,
		height: typeof props.height === 'number'
			? `${props.height}px`
			: props.height,
		minHeight: typeof props.minHeight === 'number'
			? `${props.minHeight}px`
			: props.minHeight,
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const onOpen = () => {
	dialog.value = true
}

const onClose = () => {
	emit("on-close")
	dialog.value = false
}

const onDecline = () => {
	emit("on-decline")
	dialog.value = false
}

const onAccept = () => {
	emit("on-accept")
	dialog.value = false
}

__expose({
	onOpen,
	onClose,
	onAccept,
	onDecline
})

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (dialog.value)
    ? (_openBlock(), _createBlock(_component_q_dialog, {
        key: 0,
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
        class: "base-modal-dialog",
        maximized: isMobileFullscreen.value,
        "allow-focus-outside": true,
        persistent: props.persistent && !props.closeByClickOutside,
        "no-esc-dismiss": props.persistent && props.closeByClickOutside,
        "transition-show": props.transitionShow,
        "transition-hide": props.transitionHide,
        "transition-duration": props.transitionDuration,
        onHide: onClose
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(['base-modal', { 'base-modal--fullscreen': isMobileFullscreen.value }]),
            style: _normalizeStyle(computedStyles.value)
          }, [
            (!props.hideHeader)
              ? (_openBlock(), _createBlock(_component_q_bar, {
                  key: 0,
                  class: _normalizeClass(["base-modal__bar", { 'base-modal__bar--stacked-header-right': isMobileFullscreen.value && props.stackHeaderRightOnMobile }])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(resolvedTitle.value), 1),
                    _createVNode(_component_q_space),
                    (_ctx.$slots['header-right'])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _renderSlot(_ctx.$slots, "header-right")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(AppTooltip, {
                        text: _ctx.$t('close_esc_label')
                      }, {
                        activator: _withCtx(() => [
                          _withDirectives(_createVNode(AppIcon, {
                            name: "close",
                            width: "20px",
                            color: "#979797",
                            "hover-color": "#499259",
                            cursor: "pointer",
                            onClick: onClose
                          }, null, 512), [
                            [_directive_close_popup]
                          ])
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ])
                  ]),
                  _: 3
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(AppLoader, {
                    key: 0,
                    style: _normalizeStyle(loaderStyle.value)
                  }, null, 8, ["style"]))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "default")
            ])
          ], 6)
        ]),
        _: 3
      }, 8, ["modelValue", "maximized", "persistent", "no-esc-dismiss", "transition-show", "transition-hide", "transition-duration"]))
    : _createCommentVNode("", true)
}
}

})